const priceUpdater = () =>{
    let container = document.getElementById('js-calculated-price');
    
    let NodeCompounds = document.getElementsByClassName('js-price-compound');
    
   let calculatedPrice = [...NodeCompounds].reduce( (result, price) => {
       let newPrice = parseFloat(price.dataset.price) || 0;
       result = result + newPrice;
        return result;
    },0);
   
    container.innerText = calculatedPrice.toFixed(2) || 0;
    
};

export default priceUpdater;


// WEBPACK FOOTER //
// ./components/productDetails/priceUpdater.js